<template>
  <u-text-field
    v-model="value"
    v-bind="props"
    :name="name"
    :error-messages="errors"
  >
    <template
      v-for="(slot, index) of Object.keys($slots)"
      :key="index"
      #[slot]="scope"
    >
      <slot
        :name="slot"
        v-bind="scope || {}"
      />
    </template>
  </u-text-field>
</template>

<script setup lang="ts">
const {
  name = '',
  ...definedProps
} = defineProps<{
  name?: string
  label?: string
  type?: string
}>()
const props = useDefaults(definedProps)

const { value, errors } = useField(() => name, undefined, {
  syncVModel: true,
})
</script>
